import type { DpEvent } from '@/core/events/DpEvent';

export class FacilityLoadedEvent implements DpEvent {
  static readonly eventName = 'FacilityLoaded';

  readonly name = FacilityLoadedEvent.eventName;
}
